import { levels } from "./lib.js";
import { defaultTrace } from "./tracing.js";
export * from "./subscribers/index.js";
/** Utility to compose and install multiple subscribers with a minimum log level */
export class SubscriberBuilder {
    subscriber = {};
    minLevel = "debug";
    trace;
    withSubscriber(sub, filter) {
        this.subscriber = mergeSubscribers(this.subscriber, withFilter(sub, filter));
        if (this.trace)
            this.install(this.trace);
        return this;
    }
    withMinLevel(level) {
        this.minLevel = level;
        if (this.trace)
            this.install(this.trace);
        return this;
    }
    install(trace) {
        this.trace = this.trace ?? trace ?? defaultTrace;
        this.trace.setSubscriber(withFilter(this.subscriber, this.minLevel));
    }
}
export const withFilter = (s, filter) => {
    if (!filter)
        return s;
    const f = typeof filter === "function" ? filter : (event) => levels[event.level] >= levels[filter];
    return {
        onEvent: (event) => {
            if (f(event) === false)
                return;
            s.onEvent?.(event);
        },
        onEnter: (span) => {
            if (f(span) === false)
                return;
            s.onEnter?.(span);
        },
        onExit: (span) => {
            if (f(span) === false)
                return;
            s.onExit?.(span);
        },
    };
};
const mergeSubscribers = (...subscribers) => {
    return {
        onEvent: (event) => subscribers.forEach((sub) => sub.onEvent?.(event)),
        onEnter: (span) => subscribers.forEach((sub) => sub.onEnter?.(span)),
        onExit: (span) => subscribers.forEach((sub) => sub.onExit?.(span)),
    };
};
//# sourceMappingURL=subscriber.js.map